import { ACTIVATE_ACCOUNT, ACTIVATE_ACCOUNT_FORM_DATA, ACTIVATE_ACCOUNT_NOT_FOUND } from './actions';
import {
  ACTIVATE_ACCOUNT_NOT_FOUND_STATE, DEFAULT_STATE, INTERNAL_SERVER_ERROR, PENDING_STATE,
} from '../../data/constants';
import { TPA_AUTHENTICATION_FAILURE } from '../../login/data/constants';
import { PASSWORD_RESET_FAILURE } from '../../reset-password/data/actions';

export const defaultState = {
  status: '',
  submitState: '',
  usernameEmail: '',
  usernameEmailValidationError: '',
};

const reducer = (state = defaultState, action = null) => {
  if (action !== null) {
    switch (action.type) {
      case ACTIVATE_ACCOUNT.BEGIN:
        return {
          usernameEmail: state.usernameEmail,
          status: 'pending',
          submitState: PENDING_STATE,
        };
      case ACTIVATE_ACCOUNT.SUCCESS:
        return {
          ...defaultState,
          status: 'complete',
        };
      case ACTIVATE_ACCOUNT.FORBIDDEN:
        return {
          usernameEmail: state.usernameEmail,
          status: 'forbidden',
        };
      case ACTIVATE_ACCOUNT.FAILURE:
        return {
          usernameEmail: state.usernameEmail,
          status: INTERNAL_SERVER_ERROR,
        };
      case ACTIVATE_ACCOUNT_NOT_FOUND:
        return {
          ...defaultState,
          usernameEmail: state.usernameEmail,
          submitState: DEFAULT_STATE,
          status: action.payload.errorCode === TPA_AUTHENTICATION_FAILURE
            ? TPA_AUTHENTICATION_FAILURE
            : ACTIVATE_ACCOUNT_NOT_FOUND_STATE,
          errorMessage: action.payload.errorMessage,
        };
      case PASSWORD_RESET_FAILURE:
        return {
          status: action.payload.errorCode,
        };
      case ACTIVATE_ACCOUNT_FORM_DATA: {
        const { activateAccountFormData } = action.payload;
        return {
          ...state,
          ...activateAccountFormData,
        };
      }
      default:
        return {
          ...defaultState,
          usernameEmail: state.usernameEmail,
          usernameEmailValidationError: state.usernameEmailValidationError,
        };
    }
  }
  return state;
};

export default reducer;
